document.addEventListener("visitorConsentCollected", function (event) {
  // check if shopify is loaded and customer privacy is available
  if (!window.Shopify || !window.Shopify.customerPrivacy) return;

  if (
    window.Shopify.customerPrivacy.analyticsProcessingAllowed() ||
    window.Shopify.customerPrivacy.marketingAllowed()
  ) {
    dwInitEvents();
  }
});

function dwInitEvents() {
  console.log("dwInitEvents");
  dwInitScroll();
  dwInitCartPage();
  dwInitPhoneLinks();
  dwInitEmailLinks();
  dwInitDrugWidget();
  dwInitExternalLinks();
  dwInitKooperationspartnerLinks();
  dwInitPresseLinks();
  dwInitNewsletterSignup();
  dwInitYouTubeVideoTracking();
}

// Initialize Scroll Tracking
function dwInitScroll() {
  // only for analytics
  if (!window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;

  const scrollMilestones = [25, 50, 75, 90];

  let trackedMilestones = new Set();

  let maxScroll = 0;

  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  function getScrollPercent() {
    const h = document.documentElement;
    const b = document.body;
    const st = "scrollTop";
    const sh = "scrollHeight";

    return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
  }

  // Send GA4 event
  function sendScrollEvent(percentage) {
    gtag("event", "scroll", {
      percent_scrolled: percentage,
    });
  }

  const handleScroll = debounce(() => {
    const scrollPercent = Math.round(getScrollPercent());

    maxScroll = Math.max(maxScroll, scrollPercent);

    scrollMilestones.forEach((milestone) => {
      if (maxScroll >= milestone && !trackedMilestones.has(milestone)) {
        trackedMilestones.add(milestone);
        sendScrollEvent(milestone);
      }
    });
  }, 100); // 100ms debounce delay

  window.addEventListener("scroll", handleScroll);

  window.addEventListener("beforeunload", () => {
    handleScroll();
  });
}

// user visits cart page
function dwInitCartPage() {
  if (document.body.classList.contains("template_cart")) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
          gtag("event", "view_cart", {
            ecommerce: {
              currency: cart.currency,
              value: cart.total_price / 100,
              items: cart.items.map((item) => ({
                item_id: item.id.toString(),
                item_name: item.product_title,
                item_variant: item.variant_title || "",
                price: item.price / 100,
                quantity: item.quantity,
              })),
            },
            URL: window.location.pathname,
            Titel: document.title,
          });
        }
      })
      .catch((error) => {
        // Handle errors silently
      });
  }
}

// Track clicks on telephone links
function dwInitPhoneLinks() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.href;
    if (!href || !href.toLowerCase().startsWith("tel:")) return;

    try {
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        // Send GA4 event using gtag
        gtag("event", "contact", {
          phone: window.location.pathname,
        });
      }

      if (window.Shopify.customerPrivacy.marketingAllowed()) {
        // Send Google Ads conversion
        gtag("event", "conversion", {
          send_to: "AW-11341536800/pNxOCIOM9esaEKC8iKAq",
        });

        // Send Meta Pixel event
        if (typeof window.fbq !== "undefined") {
          window.fbq("track", "Contact");
        }
      }
    } catch (e) {
      // Handle errors silently
    }
  });
}

// Track clicks on mailto links
function dwInitEmailLinks() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.href;
    if (!href || !href.toLowerCase().startsWith("mailto:")) return;

    try {
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        // Send GA4 event using gtag
        gtag("event", "contact", {
          mail: window.location.pathname,
        });
      }

      if (window.Shopify.customerPrivacy.marketingAllowed()) {
        // Send Google Ads conversion
        gtag("event", "conversion", {
          send_to: "AW-11341536800/OYryCIaM9esaEKC8iKAq",
        });

        // Send Meta Pixel event
        if (typeof window.fbq !== "undefined") {
          window.fbq("track", "Contact");
        }
      }
    } catch (e) {
      // Handle errors silently
    }
  });
}

function dwInitDrugWidget() {
  // Listen for postmessage events
  window.addEventListener("message", (event) => {
    // Check if the message has a "Result" property
    if (event.data && event.data.Result) {
      const result = event.data.Result;

      // Only track if result is "WATCH_OUT" or "OK"
      if (result === "WATCH_OUT" || result === "OK") {
        try {
          if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
            // Send GA4 event using gtag
            gtag("event", "analysis_finished", {
              Ergebnis: result,
              page: window.location.pathname,
            });
          }

          if (window.Shopify.customerPrivacy.marketingAllowed()) {
            // Send Google Ads conversion
            gtag("event", "conversion", {
              send_to: "AW-11341536800/gcGwCISZ9esaEKC8iKAq",
            });

            // meta conversion
            if (typeof window.fbq !== "undefined") {
              window.fbq("trackCustom", "Analyse durchgeführt", {
                Ergebnis: result,
                URL: window.location.pathname,
                Titel: document.title,
              });
            }
          }
        } catch (e) {
          // Handle errors silently
        }
      }
    }
  });
}

function dwInitExternalLinks() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.href;
    if (!href) return;

    try {
      const url = new URL(href);
      const domain = url.hostname.replace("www.", "");

      // Check if the link is NOT on permedio-genetik.com or its subdomains
      if (!domain.includes("permedio-genetik.com")) {
        // ga4 event
        gtag("event", "link_click", {
          URL: href,
          Titel: document.title,
        });
      }

      // Additional tracking for specific external link
      if (href === "https://pgx.permedio.at/Account/Login") {
        if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.marketingAllowed()) {
          // Fire Google Ads conversion
          gtag("event", "conversion", {
            send_to: "AW-11341536800/ceeHCICM9esaEKC8iKAq",
          });
          // Fire Facebook standard event
          if (typeof window.fbq !== "undefined") {
            window.fbq("track", "CompleteRegistration");
          }
        }
      }
    } catch (e) {}
  });
}

function dwInitKooperationspartnerLinks() {
  if (window.location.pathname === "/pages/kooperationspartner") {
    document.addEventListener("click", (event) => {
      const link = event.target.closest("a");
      if (!link) return;
      const href = link.href;
      if (!href) return;
      const isMailto = href.toLowerCase().startsWith("mailto:");
      const isTel = href.toLowerCase().startsWith("tel:");
      if (!isMailto && !isTel) return;
      try {
        if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
          // Fire GA4 event
          gtag("event", "partner_request", {
            URL: window.location.pathname,
            Titel: document.title,
          });
        }
        if (window.Shopify.customerPrivacy.marketingAllowed()) {
          // Fire Google Ads conversion
          gtag("event", "conversion", {
            send_to: "AW-11341536800/AbiMCImM9esaEKC8iKAq",
          });
          // Fire Facebook custom event
          if (typeof window.fbq !== "undefined") {
            window.fbq("trackCustom", "Partneranfrage");
          }
        }
      } catch (e) {
        // Handle errors silently
      }
    });
  }
}

function dwInitPresseLinks() {
  if (window.location.pathname === "/pages/presse") {
    document.addEventListener("click", (event) => {
      const link = event.target.closest("a");
      if (!link) return;
      const href = link.href;
      if (!href) return;
      const isMailto = href.toLowerCase().startsWith("mailto:");
      const isTel = href.toLowerCase().startsWith("tel:");
      if (!isMailto && !isTel) return;
      try {
        if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
          // Fire GA4 event
          gtag("event", "press", {
            URL: window.location.pathname,
            Titel: document.title,
          });
        }
        if (window.Shopify.customerPrivacy.marketingAllowed()) {
          // Fire Google Ads conversion
          gtag("event", "conversion", {
            send_to: "AW-11341536800/AbiMCImM9esaEKC8iKAq",
          });
          // Fire Facebook custom event
          if (typeof window.fbq !== "undefined") {
            window.fbq("trackCustom", "Presse");
          }
        }
      } catch (e) {
        // Handle errors silently
      }
    });
  }
}

function dwInitNewsletterSignup() {
  const form = document.getElementById("contact_form");
  if (form && form.classList.contains("newsletter-form")) {
    form.addEventListener("submit", function (event) {
      // Check if the form is valid
      if (typeof form.checkValidity === "function" && !form.checkValidity()) {
        return; // Let the browser handle invalid form
      }
      try {
        if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
          // Fire GA4 event
          gtag("event", "newsletter", {
            URL: window.location.pathname,
            Titel: document.title,
          });
        }
        if (window.Shopify.customerPrivacy.marketingAllowed()) {
          // Fire Google Ads conversion
          gtag("event", "conversion", {
            send_to: "AW-11341536800/I5f0CP2L9esaEKC8iKAq",
          });
          // Fire Facebook standard event
          if (typeof window.fbq !== "undefined") {
            window.fbq("track", "Subscribe");
          }
        }
      } catch (e) {
        // Handle errors silently
      }
    });
  }
}

function dwInitYouTubeVideoTracking() {
  if (!window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;

  // only if the page contains a video-play-btn button
  if (!document.querySelector(".video-play-btn")) return;

  // Load YouTube IFrame API if not already loaded
  if (!window.YT || !window.YT.Player) {
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  // Store player references to avoid duplicate tracking
  const trackedIframes = new Set();

  // Observe for new YouTube iframes added to the DOM
  const observer = new MutationObserver((mutations, obs) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.tagName === "IFRAME" && node.src && node.src.includes("youtube.com/embed")) {
          if (trackedIframes.has(node)) continue;
          trackedIframes.add(node);
          setupYouTubeTracking(node);
          obs.disconnect();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Setup YouTube API tracking for a given iframe
  function setupYouTubeTracking(iframe) {
    function onYouTubeIframeAPIReadyCheck() {
      if (window.YT && window.YT.Player) {
        createPlayer();
      } else {
        setTimeout(onYouTubeIframeAPIReadyCheck, 500);
      }
    }
    function createPlayer() {
      let progressInterval = null;
      let videoStarted = false;
      let videoCompleted = false;
      let videoTitle = "";
      let videoDuration = 0;
      const progressMilestones = [10, 25, 50, 75];
      const trackedMilestones = new Set();
      const player = new window.YT.Player(iframe, {
        events: {
          onReady: function (event) {
            // Try to get video title and duration
            try {
              videoTitle = event.target.getVideoData().title || "";
              videoDuration = event.target.getDuration() || 0;
            } catch (e) {}
          },
          onStateChange: function (event) {
            if (event.data === window.YT.PlayerState.PLAYING) {
              if (!videoStarted) {
                videoStarted = true;
                // Get title and duration if not already set
                try {
                  videoTitle = player.getVideoData().title || videoTitle;
                  videoDuration = player.getDuration() || videoDuration;
                } catch (e) {}

                gtag("event", "video_start", {
                  URL: window.location.pathname,
                  Titel: document.title,
                  video_url: iframe.src,
                  video_provider: "youtube",
                  video_title: videoTitle,
                  video_duration: videoDuration,
                  video_percent: 0,
                  video_visible: true,
                });
              }
              if (!progressInterval) {
                progressInterval = setInterval(function () {
                  try {
                    const current = Math.floor(player.getCurrentTime());
                    const percent = videoDuration > 0 ? Math.round((current / videoDuration) * 100) : 0;
                    progressMilestones.forEach((milestone) => {
                      if (percent >= milestone && !trackedMilestones.has(milestone)) {
                        trackedMilestones.add(milestone);
                        gtag("event", "video_progress", {
                          URL: window.location.pathname,
                          Titel: document.title,
                          video_url: iframe.src,
                          video_provider: "youtube",
                          video_title: videoTitle,
                          video_duration: videoDuration,
                          video_percent: milestone,
                          video_visible: true,
                        });
                      }
                    });
                  } catch (e) {}
                }, 1000);
              }
            } else {
              if (progressInterval) {
                clearInterval(progressInterval);
                progressInterval = null;
              }
              if (event.data === window.YT.PlayerState.ENDED && !videoCompleted) {
                videoCompleted = true;
                // Get title and duration if not already set
                try {
                  videoTitle = player.getVideoData().title || videoTitle;
                  videoDuration = player.getDuration() || videoDuration;
                } catch (e) {}
                gtag("event", "video_complete", {
                  URL: window.location.pathname,
                  Titel: document.title,
                  video_url: iframe.src,
                  video_provider: "youtube",
                  video_title: videoTitle,
                  video_duration: videoDuration,
                  video_percent: 100,
                  video_visible: true,
                });
              }
            }
          },
        },
      });
    }
    onYouTubeIframeAPIReadyCheck();
  }
}
